var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-sidebar navbar-collapse collapse myposition" },
    [
      _c(
        "ul",
        {
          staticClass: "page-sidebar-menu page-sidebar-menu-hover-submenu",
          attrs: {
            "data-keep-expanded": "false",
            "data-auto-scroll": "true",
            "data-slide-speed": "200"
          }
        },
        _vm._l(_vm.menu, function(item) {
          return _c(
            "li",
            {
              key: item.name,
              class: { active: item.active.indexOf(_vm.route) !== -1 }
            },
            [
              _c("router-link", { attrs: { to: { name: item.name } } }, [
                _c("i", { class: item.icon }),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._v(" "),
                _c("span", {
                  class: { selected: item.active.indexOf(_vm.route) !== -1 }
                })
              ])
            ],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ca2736e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca2736e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/Side.vue
// module id = null
// module chunks = 